export const config = {
    // API_BASE_URL: 'http://localhost:8000',
    API_BASE_URL: 'https://api.luminarentertainment.tech',
};
